export default function Footer() {
    return (
        <footer className="flex justify-center px-4 py-8 text-center">
            <p className="text-sm">
                Copyright 2025 • All Rights Reserved
            </p>
        </footer>
    )
}